<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
    <button [ngClass]="{ active: selectedTab === 1 }" (click)="selectedTab = 1">
      Processed
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-type-buy-unprocessed *ngSwitchCase="0"></app-type-buy-unprocessed>
      <app-type-buy-processed *ngSwitchCase="1"></app-type-buy-processed>
    </ng-container>
  </div>
</div>
